import React from 'react'
import { RightOutlined, EditOutlined } from '@ant-design/icons';
const CustomPickerLabel = (props) => {
  return (
    <div
      onClick={props.onClick}
      style={{ backgroundColor: '#fff', paddingLeft: 15 }}
    >
      <div className="test" style={{ display: 'flex', height: '45px', lineHeight: '45px' }}>
        <div style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {props.children}
        </div>
        <div style={{ textAlign: 'right', color: '#888', marginRight: 30}}>{props.extra}</div>
        <div style={{ textAlign: 'right', color: '#888', marginRight: 0 }}><RightOutlined /></div>
      </div>
    </div>
  )
}

export default CustomPickerLabel
